module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAAsUlEQVR4Ae2VAQbDMABF/82GAh0ALQY7xEAGucBmG6A9yoyeoT1Hz9BFGeFr2vy1BXkP0O+hCUEikgMM7KxnzPDEsNALAhxpLqau46CBDdgsSdnxswVBG0ppIUrpId/TWiG7dSji1EIhwRRaNfTGw/n5L9Qjw48MvR4q4VOqoZY2rRaqaVNroYo2lRbqaNOpP7uAT7Hz8ZvJC/lyTl1IAyLHIJgDzD06cxOebNK4dSKKL6x4JXN5kSjiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/save.png
// module id = 137
// module chunks = 0